import styled from '@emotion/styled'
import { ShowOnMarketplace } from 'shared/library/atoms/ConditionalMarketplace'
import { H5, Text } from 'library/atoms/Typography'
import Divider from 'shared/library/atoms/Divider'
import Link from 'next/link'
import { EOLA_ROUTES } from 'enums/routes'
import useTranslation from 'next-translate/useTranslation'
import { OutletPresenter } from 'shared/presenters/OutletPresenter'
import { determineHostname } from 'shared/helpers/determineHostname'

interface AboutEolaProps {
  outlet: OutletPresenter
}

const AboutEola = ({ outlet }: AboutEolaProps) => {
  const { t } = useTranslation('common')

  const domain = determineHostname().replace(/^https?:\/\/widget\./, 'https://')

  return (
    <ShowOnMarketplace>
      <StyledDivider variant="solid" />
      <AboutEolaContainer>
        <H5>{t('about-outlet', { name: 'eola' })}</H5>
        <Text fontStyle="p2" color="secondary">
          {t('about-eola-body')}
        </Text>
        <br />
        {outlet.address?.state && (
          <Text fontStyle="p2" color="secondary">
            <Link
              href={`${domain}${EOLA_ROUTES.LOCATION.url({
                location: outlet.address?.state
              })}`}
            >
              {t('explore-activities-in-state', {
                state: outlet.address?.state
              })}
            </Link>
          </Text>
        )}
      </AboutEolaContainer>
    </ShowOnMarketplace>
  )
}

export default AboutEola

const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.space[4],
  [theme.mediaQueries.lg]: {
    marginTop: theme.space[8]
  }
}))

const AboutEolaContainer = styled.div(({ theme }) => ({
  paddingTop: theme.space[4],
  [theme.mediaQueries.lg]: {
    padding: theme.space[8]
  }
}))
